export default __webpack_public_path__ + "img/bvIpPEXF.dfb52fd3.svg";